// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion dt').length > 0) {
		$(".js-accordion dt").click(function () {
			$(this).next("dd").slideToggle();
			$(this).toggleClass("is-open");
		});
	}
});
